// extracted by mini-css-extract-plugin
export default {"authSidebar":"authSidebar_authSidebar__5LKSe"};